import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Button from "components/Button";
import { Board, PageTop, Title, TitleArea } from "components/LayoutParts";
import Loading from "components/Loading";
import usePageState from "hooks/usePageState";
import { useFindLatestAiSoftwareVersions } from "pages/AimoParking/AiSoftware/api";
import AimoParkingSelect from "pages/AimoParking/component/AimoParkingSelect";
import { useFindAllEdgeDevice } from "pages/AimoParking/EdgeDevice/api";
import DataTable from "pages/AimoParking/EdgeDevice/DataTable";
import { jumpUpToElement } from "utils/animationUtils";

const ButtonWrap = styled.div`
  margin-left: auto;
`;

const Margin = styled.div`
  margin-top: 16px;
`;

const FilterWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

const FilterLabel = styled.span`
  font-weight: bold;
`;

const EdgeDevice = () => {
  const [totalPages, setTotalPages] = useState<number>(1);
  const [selectedAiSoftwareId, setSelectedAiSoftwareId] = useState<string | null>(null);

  const { currentPage, setCurrentPage } = usePageState({
    pageSymbol: "aimoParkingEdgeDeviceListView",
  });
  const navigate = useNavigate();
  const { data: latestAiSoftwares } = useFindLatestAiSoftwareVersions();
  const { data: edgeDevices, pageInfo } = useFindAllEdgeDevice({
    pageIndex: currentPage,
    aiSoftwareId: selectedAiSoftwareId ?? undefined,
  });

  const latestList = Array.isArray(latestAiSoftwares)
    ? latestAiSoftwares
    : latestAiSoftwares != null
      ? [latestAiSoftwares as AimoParkingAiSoftwareResponse]
      : [];
  const aiVersionChoices = [
    { label: "すべて", value: "" },
    ...latestList.map((item) => ({ label: item.version, value: item.id })),
  ];
  const selectedChoice =
    selectedAiSoftwareId === null || selectedAiSoftwareId === ""
      ? { label: "すべて", value: "" }
      : aiVersionChoices.find((c) => c.value === selectedAiSoftwareId) ?? null;

  const onClickEdgeDeviceAdd = () => {
    navigate("/aimo_parking/edge_device/create");
  };

  const onAiVersionChange = (choice: { label: string; value: string }) => {
    setSelectedAiSoftwareId(choice.value === "" ? null : choice.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setTotalPages(pageInfo?.totalPages ?? 1);
    return () => {
      jumpUpToElement("root");
    };
  }, [pageInfo?.totalPages]);

  return (
    <Board>
      <PageTop />
      <TitleArea>
        <Title>エッジデバイス</Title>
        <ButtonWrap>
          <Button label="エッジデバイスを登録" onClick={onClickEdgeDeviceAdd} type="primary" width="191px" />
        </ButtonWrap>
      </TitleArea>
      <Margin />
      <FilterWrap>
        <FilterLabel>AIバージョン</FilterLabel>
        <AimoParkingSelect
          choices={aiVersionChoices}
          value={selectedChoice}
          onChange={onAiVersionChange}
          width="200px"
          placeholder="すべて"
        />
      </FilterWrap>
      {edgeDevices ? (
        <DataTable
          edgeDeviceList={edgeDevices}
          totalPages={totalPages}
          pageIndex={currentPage}
          setPageIndex={setCurrentPage}
        />
      ) : (
        <Loading />
      )}
    </Board>
  );
};

export default EdgeDevice;
